// UI Actions
import { createAction, props } from '@ngrx/store';
import { Theme, Breadcrumb } from './ui.state';

// Sidebar
export const toggleSidebar = createAction('[UI] Toggle Sidebar');
export const collapseSidebar = createAction('[UI] Collapse Sidebar');
export const expandSidebar = createAction('[UI] Expand Sidebar');
export const toggleMobileSidebar = createAction('[UI] Toggle Mobile Sidebar');
export const closeMobileSidebar = createAction('[UI] Close Mobile Sidebar');

// Theme
export const setTheme = createAction(
  '[UI] Set Theme',
  props<{ theme: Theme }>()
);
export const toggleTheme = createAction('[UI] Toggle Theme');

// Notifications
export const toggleNotificationsPanel = createAction('[UI] Toggle Notifications Panel');
export const openNotificationsPanel = createAction('[UI] Open Notifications Panel');
export const closeNotificationsPanel = createAction('[UI] Close Notifications Panel');
export const setUnreadNotificationsCount = createAction(
  '[UI] Set Unread Notifications Count',
  props<{ count: number }>()
);
export const incrementUnreadNotifications = createAction('[UI] Increment Unread Notifications');
export const clearUnreadNotifications = createAction('[UI] Clear Unread Notifications');

// Modals
export const openModal = createAction(
  '[UI] Open Modal',
  props<{ modalId: string; data?: Record<string, unknown> }>()
);
export const closeModal = createAction('[UI] Close Modal');

// Global Loading
export const showGlobalLoading = createAction(
  '[UI] Show Global Loading',
  props<{ message?: string }>()
);
export const hideGlobalLoading = createAction('[UI] Hide Global Loading');

// Breadcrumbs
export const setBreadcrumbs = createAction(
  '[UI] Set Breadcrumbs',
  props<{ breadcrumbs: Breadcrumb[] }>()
);
export const addBreadcrumb = createAction(
  '[UI] Add Breadcrumb',
  props<{ breadcrumb: Breadcrumb }>()
);
export const clearBreadcrumbs = createAction('[UI] Clear Breadcrumbs');
